export const DocumentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      {...props}
    >
      <g id="Document">
        <path
          id="Vector"
          d="M21 1H3V23H21V19V1Z"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path id="Vector_2" d="M7 7L17 7" strokeLinecap="round" />
        <path id="Vector_3" d="M7 12H17" strokeLinecap="round" />
        <path id="Vector_4" d="M7 17H11" strokeLinecap="round" />
      </g>
    </svg>
  );
};
